import React from 'react';
import { volumes } from '../data/content';
import { accentDot } from '../utils/accent';

/** The six volume covers — rendered inside the "What's Included" section. */
export function Volumes() {
  return <ul className="mt-10 grid grid-cols-2 gap-x-4 gap-y-9 sm:gap-x-6 lg:mt-14 lg:grid-cols-3 lg:gap-x-10 lg:gap-y-12" data-id="element-227" data-mp="184ohyxrjo8zz">
      {volumes.map(v => <li key={v.number} className="flex flex-col" data-id="element-228" data-mp="1c3e3xeqneyv8">
          <img src={v.cover} alt={`Volume ${v.number} cover: ${v.title}`} loading="lazy" className="aspect-[1055/1491] w-full rounded-md object-cover shadow-cover" data-id="element-229" data-mp="1zw4d5g76341t" />
          <p className="mt-4 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-mute sm:text-[12px]" data-id="element-230" data-mp="1qtv0oksc90ls">
            <span className={`h-2 w-2 rounded-full ${accentDot[v.accent]}`} aria-hidden="true" data-id="element-231" data-mp="ff7sa7vb767g" />
            Volume {v.number}
          </p>
          <h3 className="mt-1.5 font-display text-[18px] leading-tight text-ink sm:text-[24px]" data-id="element-232" data-mp="kfc77tgkjsvk">{v.title}</h3>
          <p className="mt-1.5 text-[14px] leading-snug text-ink-soft sm:text-[16px]" data-id="element-233" data-mp="3o8yal1vp0nou">{v.description}</p>
        </li>)}
    </ul>;
}